import { useMutation } from "react-query";
import {
  VehicleLicensePlateRequestParams,
  deleteVehicleLicensePlate,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const deleteVehicleLicensePlateFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: VehicleLicensePlateRequestParams;
}) => {
  return await deleteVehicleLicensePlate(rowVersion, params);
};

export function useDeleteVehicleLicensePlate() {
  return useMutation(deleteVehicleLicensePlateFn, {
    mutationKey: MUTATION_KEYS.deleteVehicleLicensePlate,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
